module.exports = __webpack_public_path__ + "img/third_trophy.3607f88e.svg";